import { cx } from "../lib/cx";

/**
 * Light glass ground shared by Settings and Integrations.
 * Matches Documents: tokens resolve under `data-theme="light"` on the page,
 * so the screen stays light even when the stored product theme is dark.
 */
export const settingsPageClass = cx(
  "font-ds -mx-5 -mb-5 flex min-h-full min-w-0 flex-1 flex-col gap-ds-cards overflow-x-hidden bg-fixed px-ds-page-x py-ds-page-y text-ds-ink",
  "max-[900px]:-mx-3 max-[900px]:-mb-3 max-[900px]:px-3 max-[900px]:py-3",
  "[@media(max-height:760px)]:gap-2.5 [@media(max-height:760px)]:px-4 [@media(max-height:760px)]:py-3",
);

export const settingsPageStyle = {
  colorScheme: "light" as const,
  backgroundImage:
    "radial-gradient(900px 500px at 78% -10%, rgba(255,255,255,.55), transparent 60%), radial-gradient(700px 500px at 0% 100%, rgba(241,194,50,.12), transparent 60%), linear-gradient(160deg, var(--ds-bg-a), var(--ds-bg-b))",
};

/** Pill field. Explicit font and padding so Preflight compat does not leak in. */
export const settingsControl = cx(
  "m-0 h-[38px] w-full min-w-0 rounded-ds-pill border-0 bg-ds-glass-strong px-3.5 py-0 text-ds-body font-normal text-ds-ink outline-none [font-family:inherit]",
  "placeholder:text-ds-ink-3 read-only:text-ds-ink disabled:cursor-default disabled:text-ds-ink-3",
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-ds-ink",
);

export const settingsToggle = cx(
  "relative m-0 h-[22px] w-10 shrink-0 cursor-pointer appearance-none rounded-ds-pill border-0 bg-ds-glass-strong p-0 [font-family:inherit]",
  "after:absolute after:top-0.5 after:left-0.5 after:size-[18px] after:rounded-full after:bg-white after:shadow-sm after:content-['']",
  "checked:bg-ds-amber checked:after:translate-x-[18px]",
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-ds-ink",
  "disabled:cursor-default",
);

export const settingsRadio = "m-0 size-4 shrink-0 accent-ds-amber";
